$('.js-hasChild').click(function() {
  $(this).parent().toggleClass("is-active");
 });